// init Masonry
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export const initMasonry = () => {
// init Masonry
	let grid = document.querySelector('.grid');

	let msnry = new Masonry(grid, {
		itemSelector   : '.grid-item',
		columnWidth    : '.grid-sizer',
		percentPosition: true,
		gutter         : '.gutter-sizer'
	});

	imagesLoaded(grid).on('progress', () => {
		msnry.layout();
	});

};



// WEBPACK FOOTER //
// ./js/custom/masonry.js